<template>
  <div class="hello">
    <el-container>
        <el-header style="height:100%">
            <div v-show="showWechatConnStartDig" style="position: fixed; top: 0; left: 0; height: 100%; width: auto; background-color: rgba(0, 0, 0, 0.7); z-index:12;">
                <img src="../assets/Healthconn_Wechat@3x.png" alt="" width="100%">
            </div>
            <span v-show="showNanshanLifeLogo==false && showCathayLogo==false && showDrwellsLogo==false && showHealthConnLogo==false && showNCKUDLLogo==false && showMaTsuhLogo==false">
                <img src="../assets/info3.png" height="110" alt="">
            </span>
            <span v-show="showCathayLogo==true">
                <img src="../assets/logo_cathay.jpg" height="110" width="270" alt="">
            </span>
            <span v-show="showNanshanLifeLogo==true">
                <img src="../assets/logo_nanshanlife.jpg" height="110" width="270" alt="">
            </span>
            <span v-show="showTaiwanLifeLogo==true">
                <img src="../assets/logo_taiwanlife.jpg" height="110" width="270" alt="">
            </span>
            <span v-show="showDrwellsLogo==true">
                <img src="../assets/drwells_logo.png" height="110" width="270" alt="">
            </span>
            <span v-show="showHealthConnLogo==true">
                <img src="../assets/logo_healthconn.jpg" height="110" width="270" alt="">
            </span>
            <span v-show="showNCKUDLLogo==true">
                <img src="../assets/Logo_HospNckuD6.png" height="160" width="250" alt="">
            </span>
            <span v-show="showMaTsuhLogo==true">
                <img src="../assets/Logo_MaTsuhB.png" height="150" width="170" alt="">
            </span>
            <span v-show="showXTestLogo==true">
            </span>
        </el-header>
        <el-main>
            <el-row class="row-bg" justify="center" v-show="(source=='fb_covid19' || source=='' || source==undefined) && formactive==false " style='max-width: 400px;margin: 0 auto;'>
                <h3 style="margin:0 0 20px 0">{{$t("main.default_title")}}</h3>
                <span v-if="source=='' || source==undefined" @click="calluia">
                    <img v-if="$i18n.locale=='zh_CN'" src="../assets/Fb-UIA-cn.png" width="100%" alt="">
                    <img v-else src="../assets/Fb-UIA-tw.png" width="100%" alt="">
                </span>
                <span @click="callPartner24hour()">
                    <img v-if="$i18n.locale=='zh_CN'" src="../assets/Fb-24hr-cn.png" width="100%" alt="">
                    <img v-else src="../assets/Fb-24hr-tw.png" width="100%" alt="">
                </span>
                <span @click="orderDoxtor">
                    <img v-if="$i18n.locale=='zh_CN'" src="../assets/Fb-reservation-cn.png" width="100%" alt="">
                    <img v-else src="../assets/Fb-reservation-tw.png" width="100%" alt="">
                </span>
                <span @click="myQueue">
                    <img v-if="$i18n.locale=='zh_CN'" src="../assets/Fb-research-cn.png" width="100%" alt="">
                    <img v-else src="../assets/Fb-research-tw.png" width="100%" alt="">
                </span>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center" v-show="formactive==false && (source=='' || source==undefined)">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.service_info")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.service_msg")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.pay_info")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.pay_msg")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.pay_way")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.pay_way_msg")}}</h4>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center" v-show="source=='fb_covid19' && formactive==false " style='max-width: 400px;margin: 0 auto;'>
                <el-col :xs="22" :sm="22">
                    
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.service_info")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.service_msg")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.pay_info")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.pay_msg")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">{{$t("main.pay_way")}}</h4>
                    <h4 style="text-align: left; margin-top: -10px;">{{$t("main.pay_way_msg")}}</h4>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center" v-show="formactive==false">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
                    <h3>台灣醫師線上諮詢服務</h3>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">服務人員</h4>
                    <h4 style="text-align: left; margin-top: -10px;">由可說中英雙語的台灣醫師及護理師提供在線視訊/語音保健諮詢服務。</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">費用說明</h4>
                    <h4 style="text-align: left; margin-top: -10px;">依照您選定的醫師及咨詢分鐘數計算費用，若諮詢超過預訂的時間，系統將請您於完成諮詢後依該醫師每分鐘諮詢費率補繳差額，不足一分鐘仍以一分鐘計算。</h4>
                    <h4 style="text-align: left; margin-top: -10px; color: coral;">支付方式</h4>
                    <h4 style="text-align: left; margin-top: -10px;">提供信用卡、銀聯卡及 Line Pay 在線支付。</h4>
                </el-col>
                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                    <div>
                        <el-button type="danger" @click="call24hour" style="width:95%">+ 24小時急診醫師</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center" v-show="formactive==false && (source=='' || source==undefined)">
                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                    <div>
                        <el-button type="primary" @click="orderDoxtor" style="width:95%">找醫事人員</el-button>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                    <div>
                        <el-button type="danger" @click="myQueue" style="width:95%">預約問診</el-button>
                    </div>
                </el-col>
            </el-row>
            
            <el-row type="flex" class="row-bg" justify="center" v-show="formactive" style='max-width: 400px;margin: 0 auto;'>
                <el-col>
                    <div v-if="showNCKUDLLogo==false && source!='fb_covid19'">
                        <h1 v-show="showCathayLogo==true">{{$t("main.uia_title")}}</h1>
                        <h3 style="margin:0 0 20px 0" v-show="showCathayLogo==false && showMaTsuhLogo==false">{{$t("main.default_title")}}</h3>
                        <span class="nomaltitle" v-show="showCathayLogo==false && showMaTsuhLogo==false">{{$t("main.first_start_msg")}}</span>
                        <span class="cathaytitle" style="font-size:large;font-weight: 600;" v-show="showCathayLogo==true">{{$t("main.signup_msg")}}</span><br/>
                        <span style="color: red; font-size:small;" v-show="showCathayLogo==true">{{$t("main.uia_msg")}}</span>
                    </div>
                    <div v-if="showMaTsuhLogo==true">
                        <h1 v-show="showMaTsuhLogo==true">{{$t("main.covid19_title")}}</h1>
                        <h3 v-show="showMaTsuhLogo==true" style="margin-top: 10px; color: #dc2b19;">{{$t("main.signup_msg")}}</h3>
                        <span class="nomaltitle" style="font-size:14px; margin-top: 8px;" v-show="showCathayLogo==false">{{$t("main.signup_warring_msg")}}</span>
                        <span class="cathaytitle" style="font-size:large;font-weight: 600;" v-show="showCathayLogo==true">{{$t("main.signup_msg")}}</span><br/>
                        <span style="color: red; font-size:small;" v-show="showCathayLogo==true"> {{$t("main.uia_service_info")}}</span>
                    </div>
                    <div v-if="source=='fb_covid19'">
                        <h3 style="margin:0 0 20px 0">{{$t("main.default_title")}}</h3>
                        <span style="font-size: 12px;">{{$t("main.first_start_msg")}}</span>
                    </div>
                    <LoginRegister  v-if="source==undefined || source=='' || new_login_source.indexOf(source)>-1" :partner='partnerId' :device_token='myDeviceToken' :refresh_url='refresh_url' :api_base_url='api_base_url' />
                    <el-form v-else style="padding-top: 30px;" ref="form" :model="form" label-width="80px">
                    <el-form-item :label="$t('form.name')">
                        <el-input v-model="form.name" :placeholder="$t('form.name_p')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.mobile')">
                        <el-input v-model="form.mobile" :placeholder="$t('form.mobile_p')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.tw_id')">
                        <el-input v-model="form.account" :placeholder="$t('form.tw_id_p')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.user_code')" v-show="selecttype == 'healthconn' || selecttype == 'xtest'">
                        <el-input v-model="form.uid" :placeholder="$t('form.user_code_p')"></el-input>
                    </el-form-item>
                    <el-form-item label="" style="text-align: left; width: 350px;">
                        <span v-show="showCathayLogo==false && showNCKUDLLogo==false && showMaTsuhLogo==false">
                            <el-checkbox v-model="agreed"><span style="cursor: pointer;">{{$t("form.i_agree")}}</span> </el-checkbox><span class="privacy" @click="showAgreed" style="color: red; cursor: pointer;margin">{{$t("form.private_role")}}</span>
                        </span>
                        <span v-show="showNCKUDLLogo==true">
                            <el-checkbox v-model="agreed" style="margin-right: 0!important;" size="medium"><span style="cursor: pointer;color: red; ">{{$t("main.i_agree")}}</span> </el-checkbox><span class="privacy" @click="showAgreed" style="color: red; cursor: pointer;">{{$t("form.private_user_role")}}</span>
                        </span>
                        <span v-show="showCathayLogo==true">
                            <el-checkbox v-model="agreed" style="left: -30px; " size="medium"><span style="cursor: pointer;">{{$t("form.i_agree")}}</span> </el-checkbox><span class="privacy" @click="showAgreed" style="color: #409EFF; position: relative; left: -30px; cursor: pointer;">{{$t("form.private_user_role")}}</span>
                        </span>
                        <span v-show="showMaTsuhLogo==true">
                            <el-checkbox v-model="agreed" style="left: -30px; " size="medium"><span style="cursor: pointer;">{{$t("form.i_agree")}}</span> </el-checkbox><span class="privacy" @click="showAgreed" style="color: #409EFF; position: relative; left: -30px; cursor: pointer;">{{$t("form.private_user_role")}}</span>
                        </span>
                    </el-form-item>
                    <el-form-item>
                        <span v-show="showCathayLogo==false && showDrwellsLogo==false && showHealthConnLogo==false && showNCKUDLLogo==false && showMaTsuhLogo==false">
                            <el-button type="primary" @click="onSubmit" :disabled="!agreed">{{$t("main.call_staff")}}</el-button>
                        </span>
                        <span v-show="showCathayLogo==true || showNCKUDLLogo==true">
                            <el-button type="success" @click="onSubmit" :disabled="!agreed" style="width: 200px; position: relative;left: -40px;">{{$t("main.send_call")}}</el-button>
                        </span>
                        <span v-show="showMaTsuhLogo==true">
                            <el-button type="success" @click="onSubmit" :disabled="!agreed" style="width: 200px; position: relative;left: -40px;">{{$t("main.send_call")}}</el-button>
                        </span>
                        <span v-show="showDrwellsLogo==true">
                            <el-button type="success" @click="onSubmit" :disabled="!agreed" style="width: 200px; position: relative;left: -40px;">{{$t("main.call_service")}}</el-button>
                        </span>
                        <span v-show="showHealthConnLogo==true">
                            <el-button type="success" @click="onSubmit" :disabled="!agreed" style="width: 200px; position: relative;left: -40px; background-color: #F29D20; border-color: #F29D20;">{{$t("main.send_call")}}</el-button>
                        </span>
                        
                    </el-form-item>
                    </el-form>
                    
                </el-col>
            </el-row>
        </el-main>
        <span v-show="showNanshanLifeLogo==false && showCathayLogo==false && showHealthConnLogo==false && showNCKUDLLogo==false && showMaTsuhLogo==false">
            <!-- <el-button type="primary" id="getAccessToken">主要按钮</el-button><p id="accessTokenField"></p>
            <el-button type="primary" id="liffLoginButton">LOGIN</el-button><p id="accessTokenField"></p>
            <el-button type="primary" id="liffLogoutButton">LOGOUT</el-button><p id="accessTokenField"></p> -->
            <el-footer id="footer">{{$t("main.service_footer")}}
                <span v-show="showDrwellsLogo==true">
                    <img src="../assets/drwells_logo_cp.png" height="40" alt="">
                </span>
            </el-footer>
            <el-footer style="height: 30px;" id="footer_service">{{$t("main.service_from")}} <a href="#"></a></el-footer>
            
        </span>
        <span v-show="showCathayLogo==true">
            <img src="../assets/img_copyright.jpg" height="40" alt="">
        </span>
        <span v-show="showNCKUDLLogo==true">
            <img src="../assets/HospNckud6-Service.png" height="20" alt="NCKU Service">
        </span>
        <span v-show="showMaTsuhLogo==true">
            <img src="../assets/MaTsuhB-servie.png" height="50" alt="MaTsuhb Service">
        </span>
        
    </el-container>
    <el-dialog
        :title="$t('main.extrea_browser')"
        :visible.sync="showMountedDig"
        width="95%">
        
        <span>
        <p style="color: red">{{$t("main.webview_warring")}}</p>
        </span>
    </el-dialog>
    <el-dialog
        :title="$t('main.extrea_browser')"
        :visible.sync="showHealthConnStartDig"
        width="95%">
        <span>
        <p style="color: red">{{$t("main.webview_warring")}}</p>
        </span>
    </el-dialog>
    <!-- <el-dialog
        id="wechatdig"
        :show-close=false
        :visible.sync="showWechatConnStartDig"
        width="100%" top="0">
        <span>
            <img src="../assets/Healthconn_Wechat@3x.png" alt="" style="background-color: black;">
        <span ><p style="color: red">WE CHAT</p>
        </span>
    </el-dialog> -->
    <el-dialog
        :title="$t('main.popup_title')"
        :visible.sync="showAgreedDig"
        width="95%">
        <span v-html='$t("main.private_note")' style='text-align: left;'></span>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="showAgreedDig = false">取 消</el-button> -->
            <el-button type="primary" @click="showAgreedDig = false">{{$t("main.agree")}}</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import Fingerprint2 from 'fingerprintjs2'
import axios from 'axios'
import LoginRegister from './LoginRegister.vue'
export default {
    name: 'Main',
    props: {
        msg: String
    },
    components: {
        LoginRegister,
    },
    data() {
        return {
            myDeviceToken: '',
            uiaConnectToken: '',
            activeIndex: '1',
            activeIndex2: '1',
            formactive: false,
            showAgreedDig: false,
            showMountedDig: false,
            showHealthConnStartDig: false,
            showWechatConnStartDig: false,
            partnerId: '31',
            agreed: false,
            selecttype: 'uia',
            source: '',
            form: {
                uid: '',
                name: '',
                mobile: '',
                account: ''
            },
            showCathayLogo: false,
            showNanshanLifeLogo: false,
            showTaiwanLifeLogo: false,
            showDrwellsLogo: false,
            showHealthConnLogo: false,
            showNCKUDLLogo: false,
            showMaTsuhLogo: false,
            showXTestLogo: false,
            refresh_url:process.env.VUE_APP_URL+'/v3/#/',
            api_base_url:process.env.VUE_APP_API_URL+'/app/restful_api',
            new_login_source:['fb_covid19']
        };
    },
    mounted() {
        var _self = this
        _self.myDeviceToken = sessionStorage.getItem('deviceTokenKey');
        if(sessionStorage.getItem('tokenId')){
            _self.uiaConnectToken = sessionStorage.getItem('tokenId');
        }else{
            Fingerprint2.getV18(function (result) {
                _self.myDeviceToken = result
                sessionStorage.setItem('deviceTokenKey', _self.myDeviceToken);
            })
        }
        let githubURL = new URL(window.location.href);
        // let params = window.location.search;
        // const googleSearchURL = new URL(window.location.search)
        let params  = githubURL.searchParams;
        let mydata = [];
        for (let pair of params .entries()) {
            mydata.push(pair[1])
        }
        // this.isWebview();
        _self.source = mydata[0];
        console.log(_self.source);
        if(mydata[0]=='cathay'){
            _self.showCathayLogo = true;
            _self.formactive = true;
            _self.selecttype = 'cathay';
            _self.showMountedDig = true;
        }else if(mydata[0]=='nanshanlife'){
            _self.showNanshanLifeLogo = true;
            _self.formactive = true;
            _self.selecttype = 'nanshanlife';
            _self.showMountedDig = true;
        }else if(mydata[0]=='taiwanlife'){
            _self.showTaiwanLifeLogo = true;
            _self.formactive = true;
            _self.selecttype = 'taiwanlife';
            _self.showMountedDig = true;
        }else if(mydata[0]=='drwells'){
            _self.showDrwellsLogo = true;
            _self.formactive = true;
            _self.selecttype = 'drwells';
            _self.partnerId = '25';
            // _self.showMountedDig = true
        }else if(mydata[0]=='hospnckud6'){
            // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = '/faviconncku.ico';
            document.getElementsByTagName('head')[0].appendChild(link);
            document.title = this.$i18n.t("main.hospnckud6_title")
            _self.showNCKUDLLogo = true
            _self.formactive = true
            _self.selecttype = 'hospnckud6'
            _self.partnerId = '30'
        }else if(mydata[0]=='matsuhb'){
            // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = '/faviconmatsuh.ico';
            _self.showMountedDig = true
            // console.log('link ', link)
            document.getElementsByTagName('head')[0].appendChild(link);
            document.title = this.$i18n.t("main.matsuhb_title")
            _self.showMaTsuhLogo = true
            _self.formactive = true
            _self.selecttype = 'matsuhb'
            _self.partnerId = '4'
            // _self.showMountedDig = true
        }else if(mydata[0]=='healthconn'){
            var ua = navigator.userAgent.toLowerCase();
            var wechat = false
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                wechat = true
            }
            // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = '/favicon2.ico';
            // console.log('link ', link)
            document.getElementsByTagName('head')[0].appendChild(link);
            document.title = this.$i18n.t("main.healthconn_title")
            _self.showHealthConnLogo = true
            _self.formactive = true
            _self.selecttype = 'healthconn'
            _self.partnerId = '28'
            if(wechat){
                _self.showWechatConnStartDig = true
                _self.showHealthConnStartDig = false
                return false
            }else{
                _self.showWechatConnStartDig = false
                _self.showHealthConnStartDig = true
            }
        }else if(mydata[0]=='xtest'){
            _self.showXTestLogo = true
            _self.formactive = true
            _self.selecttype = 'xtest'
            _self.partnerId = '29'
            // _self.showMountedDig = true
        }else if(mydata[0]=='anyhealth'){
            console.log(params.get('account'));
            console.log(params.get('mobile'));
            console.log(params.get('name'));
            console.log(params.get('password'));
            console.log(params.get('sex'));
            _self.partnerId = '2096'
            // this.quickRegister(params);
            // window.location.replace("https://patient.curdoctor.com.tw/v3/#/?deviceToken="+_self.myDeviceToken)
        }
        // console.log('form', this.showCathayLogo)
        this.$eventBus.$on('login_done', function (data) {
                if (data){
                    _self.formactive = false
                    _self.uiaConnectToken=sessionStorage.getItem("tokenId")
                }
            },this);
    },
    methods: {
        callService() {
            var _self = this
            // console.log('form', this.form)
            // window.location.assign(process.env.VUE_APP_URL+"/v3/#/doctor24/0/partner_"+_self.partnerId+"?service_only=1&platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
            window.location.assign(process.env.VUE_APP_URL+"/v3/#/doctor24/0/partner_"+_self.partnerId+"?service_only=1&platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
        },
        removeLocalStorage() {
            sessionStorage.removeItem('deviceTokenKey')
            sessionStorage.removeItem('tokenId')
            this.myDeviceToken = ''
            this.uiaConnectToken = ''
        },
        calluia() {
            var _self = this
            if(_self.uiaConnectToken == '' || _self.myDeviceToken == ''){
                _self.formactive = true
                _self.refresh_url=_self.selecttype=='uia'?_self.refresh_url+'uia/cathay_life_insurance':_self.refresh_url+'emergency/'
            }else{
                _self.formactive = false
                if(_self.selecttype=='uia'){
                    window.open(process.env.VUE_APP_URL+"/v3/#/uia/cathay_life_insurance?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                }else{
                    window.open(process.env.VUE_APP_URL+"/v3/#/emergency/?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                }
            }
            _self.selecttype = 'uia'
        },
        call24hour() {
            var _self = this
            _self.selecttype = '24hour'
            if(_self.uiaConnectToken=='' || _self.myDeviceToken == ''){
                _self.formactive = true
                _self.refresh_url=_self.selecttype=='uia'?_self.refresh_url+'uia/cathay_life_insurance':_self.refresh_url+'emergency/'
            }else{
                _self.formactive = false
                if(_self.selecttype=='uia'){
                    window.open(process.env.VUE_APP_URL+"/v3/#/uia/cathay_life_insurance?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                }else{
                    window.open(process.env.VUE_APP_URL+"/v3/#/emergency/?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                }
            }
        },
        callPartner24hour() {
            var _self = this
            _self.selecttype = 'callPartner24hour'
            if(_self.uiaConnectToken=='' || _self.myDeviceToken == ''){
                _self.formactive = true
                _self.refresh_url=_self.refresh_url+'doctor24/0/emergency/'
            }else{
                _self.formactive = false
                window.open(process.env.VUE_APP_URL+"/v3/#/doctor24/0/emergency/?platform=web"+(_self.partnerId!=''?'&partner='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
            }
        },
        orderDoxtor() {
            var _self = this
            _self.selecttype = 'orderDoxtor'
            if(_self.uiaConnectToken=='' || _self.myDeviceToken == ''){
                _self.formactive = true
                _self.refresh_url=_self.refresh_url+'finddoctor/0/0/1'
            }else{
                _self.formactive = false
                window.open(process.env.VUE_APP_URL+"/v3/#/finddoctor/0/0/1?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
            }
        },
        myQueue() {
            var _self = this
            _self.selecttype = 'myQueue'
            if(_self.uiaConnectToken=='' || _self.myDeviceToken == ''){
                _self.formactive = true
                _self.refresh_url=_self.refresh_url+'myqueue/'
            }else{
                _self.formactive = false
                window.open(process.env.VUE_APP_URL+"/v3/#/myqueue/?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
            }
        },
        showAgreed() {
            this.showAgreedDig = true
        },
        onSubmit() {
            var _self = this
            if(_self.form.account=='' || _self.form.mobile =='' || _self.form.name==''){
                _self.$alert(this.$i18n.t("main.form_warring"), this.$i18n.t("main.warring"), {
                    confirmButtonText: this.$i18n.t("main.agree"),
                })
                return false
            }
            if( _self.selecttype=='healthconn' && _self.form.uid==''){
                _self.$alert(this.$i18n.t("main.form_warring"), this.$i18n.t("main.warring"), {
                    confirmButtonText: this.$i18n.t("main.agree"),
                })
                return false
            }
            
            var url = process.env.VUE_APP_API_URL+'/app/restful_api/user/quickRegister'
            var bodyFormData = new FormData()
            bodyFormData.set('account', _self.form.account)
            bodyFormData.set('mobile', _self.form.mobile)
            bodyFormData.set('name', _self.form.name)
            bodyFormData.set('token', _self.myDeviceToken)
            bodyFormData.set('partner_id', _self.partnerId)
            if(_self.selecttype=='healthconn' || _self.selecttype=='xtest'){
                // bodyFormData.set('enterprise_id', _self.enterpriseId)
                bodyFormData.set('employee_id', _self.form.uid)
            }
            axios({
                method: 'post',
                url: url,
                data: bodyFormData,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
                })
                .then(function (response) {
                    //handle success
                    if(response.data.status=="OK"){
                        sessionStorage.setItem('tokenId', response.data.token)
                        sessionStorage.setItem('voipToken', _self.myDeviceToken)
                        // sessionStorage.setItem('tokenId', response.data.token)
                        _self.uiaConnectToken = response.data.token
                        if(_self.selecttype=='uia'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/uia/default?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }else if(_self.selecttype=='cathay'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/uia/cathay_life_insurance?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }else if(_self.selecttype=='nanshanlife'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/uia/nanshanlife?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }else if(_self.selecttype=='taiwanlife'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/uia/taiwanlife?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }else if(_self.selecttype=='drwells'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/doctor24/0/partner_"+_self.partnerId+"?service_only=1&platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }else if(_self.selecttype=='healthconn' || _self.selecttype=='xtest'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/uia/healthconn?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken+"&partner_id="+response.data.partner_id)
                        }else if(_self.selecttype=='hospnckud6'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/partner_memo/30?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken+"&partner_id="+response.data.partner_id)
                        }else if(_self.selecttype=='matsuhb'){
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/partner_memo/4?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken+"&partner_id="+response.data.partner_id)
                        }else{
                            window.location.assign(process.env.VUE_APP_URL+"/v3/#/emergency/?platform=web"+(_self.partnerId!=''?'&partner_id='+_self.partnerId:'')+"&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken)
                        }
                    }else{
                        if(response.data.status=="ERROR" && response.data.msg=="your partner member needs auth"){
                            alert(_self.$i18n.t("main.matsuhb_return_msg"))
                            return false
                        }else{
                            _self.$alert(_self.$i18n.t("main.form_warring"), _self.$i18n.t("main.warring"), {
                                confirmButtonText: _self.$i18n.t("main.agree"),
                            })
                        }
                    }
                })
                .catch(function () {});
        },
        quickRegister(params) {
            var _self = this;
            var url = 'https://api.curdoctor.com.tw/app/restful_api/user/quickRegister';
            var bodyFormData = new FormData();
            bodyFormData.set('account', params.get('account'));
            bodyFormData.set('mobile', params.get('mobile'));
            bodyFormData.set('name', params.get('name'));
            bodyFormData.set('token', _self.myDeviceToken);
            bodyFormData.set('partner_id', _self.partnerId);
            axios({
                method: 'post',
                url: url,
                data: bodyFormData,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then(function (response) {
                //handle success
                if (response.data.status=="OK") {
                    sessionStorage.setItem('tokenId', response.data.token);
                    sessionStorage.setItem('voipToken', _self.myDeviceToken);
                    window.location.replace("https://patient.curdoctor.com.tw/v3/#/doctor24/0/partner_"+_self.partnerId+"?service_only=1&tokenId="+_self.uiaConnectToken+"&deviceToken="+_self.myDeviceToken);
                } else {
                    console.log('quickRegister fales');
                    console.log(response);
                }
            })
            .catch(function () {});
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    button { cursor:pointer; }
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .cathaytitle {
        margin: 20px 0 20px;
    }
    .el-row {
        margin-top: 40px;
        padding-top: 10px;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .subtitle {
        color: coral;
    }
    #footer {
        position: relative;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    p {
        text-align: left;
    }
    #footer_service {
        font-size: 14px;
        margin-top: -1rem;
    }
    /* #wechatdig > div.el-dialog {
        margin-top: 0 !important;
    } */
    #wechatdig.el-dialog__headerbtn {
        /* position: absolute;
        top: 20px; */
        left: 20px !important;
        /* padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 16px; */
    }
    /* .el-form-item__content {
        width: 250px !important;
    } */
    
    
</style>
<style lang="css">
    .el-checkbox__inner {
        width: 30px !important;
        height: 30px !important;
    }
    .el-checkbox__inner::after {
        left: 14px !important;
        height: 14px !important;
        top: 4px;
    }
</style>
